import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AssignNewProducts from '../../components/blocks/AssignNewProducts';
import Toolbar from '../../components/common/Toolbar';

import {
  getProductsReplenish,
  setProductsReplenishOffset,
  setProductsReplenishCurrentFilter,
  getProductsReplenishRetailers,
  productsReplenishCheck,
  productsReplenishUncheck,
  setProductsReplenishSearch,
  productsReplenishSubmit,
  setProductsReplenish,
} from '../../store/actions/productsReplenish';
import { setProductFiltersSearch } from '../../store/actions/productFilters';
import { getSupplierProductFilters } from '../../store/actions/suppliers';
import { StaticFilters } from '../../constants/staticFilters';

function ProductsReplenishContainer(props) {
  const dispatch = useDispatch();
  const { getProductsFilters, getProducts, getProductsRetailers } = props;

  useEffect(() => {
    getProductsFilters();
    getProducts();
    getProductsRetailers();

    return () => {
      dispatch(setProductsReplenish(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const staticFilters = [
    StaticFilters.HAS_INVENTORY,
    StaticFilters.ASSIGNED_TO_RETAILERS,
    StaticFilters.ACTIVE_PRODUCTS,
  ];

  return (
    <div>
      <Toolbar name="Reorder Catalogue Management" />
      <AssignNewProducts staticFilters={staticFilters} {...props} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { data, count, retailers, checked = {}, perPage, search, offset, loading } = state.productsReplenish;

  const { filters, currentFilters, currentFilterSearches } = state.productFilters;
  const canUserDoActions = state.role.user.is_super_admin && ['support', 'admin'].includes(state.role.user.role);

  return {
    data,
    retailers,
    checked,
    perPage,
    offset,
    loading,
    searchQuery: search,
    filters,
    currentFilters,
    currentFilterSearches,
    pageCount: Math.ceil(count / perPage),
    canUserDoActions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getProducts: () => dispatch(getProductsReplenish()),
  setPage: (offset) => dispatch(setProductsReplenishOffset(offset)),
  getProductsFilters: () => dispatch(getSupplierProductFilters()),
  setFilter: (filter) => dispatch(setProductsReplenishCurrentFilter(filter)),
  setFilterSearch: (filter, search) => dispatch(setProductFiltersSearch(filter, search)),
  getProductsRetailers: () => dispatch(getProductsReplenishRetailers()),
  check: (id) => dispatch(productsReplenishCheck(id)),
  uncheck: (id) => dispatch(productsReplenishUncheck(id)),
  productSearch: (search) => dispatch(setProductsReplenishSearch(search)),
  submit: (value) => dispatch(productsReplenishSubmit(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsReplenishContainer);

ProductsReplenishContainer.propTypes = {
  setPage: PropTypes.func.isRequired,
  data: PropTypes.array,
  retailers: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  getProductsFilters: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setFilterSearch: PropTypes.func.isRequired,
  getProductsRetailers: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
  uncheck: PropTypes.func.isRequired,
  checked: PropTypes.object,
  productSearch: PropTypes.func.isRequired,
  loading: PropTypes.shape({
    products: PropTypes.bool,
  }),
};
